import { initI18n } from './locales';
import { ConfigProvider } from 'antd';
import Bowser from 'bowser';
import 'pepjs'; // 指针事件垫片
import { StrictMode } from 'react';
import ReactDOM from 'react-dom';
import { IntlProvider } from 'react-intl'; // i18n
import { Provider } from 'react-redux';
import { BrowserRouter as Router } from 'react-router-dom';
import App from './App';
import './fontAwesome'; // Font Awesome
import './index.css';
import store from './store';
import {
  setDarkMode,
  setOSName,
  setPlatform,
  setRuntimeConfig,
} from './store/site/slice';
import { setUserToken } from './store/user/slice';
import { applyBrandFavicon } from './hooks/useBrandAssets';
import { getToken } from './utils/cookie';
import { OSName, Platform } from './interfaces';
import { runtimeConfig } from './configs';
import {
  getDefaultHotKey,
  hotKeyInitialState,
  HotKeyState,
  setHotKey,
} from './store/hotKey/slice';
import { loadHotKey, themeStorage } from './utils/storage';
import { createDebugLogger } from './utils/debug-logger';
const debugLogger = createDebugLogger('app');

// 浏览器识别
const browser = Bowser.getParser(window.navigator.userAgent);
const platform = browser.getPlatformType() as Platform;
const osName = browser.getOSName(true) as OSName;
store.dispatch(setPlatform(platform));
store.dispatch(setOSName(osName));
// 恢复自定义快捷键
for (const hotKeyName in hotKeyInitialState) {
  const name = hotKeyName as keyof HotKeyState;
  for (const index of [0, 1]) {
    const loadedHotKey = loadHotKey({ name, index });
    if (loadedHotKey !== 'disabled') {
      let option;
      if (loadedHotKey) {
        option = loadedHotKey;
      } else {
        option = getDefaultHotKey({ name, index, osName });
      }
      store.dispatch(setHotKey({ name, index, option }));
    }
  }
}

// 读取暗色模式偏好并应用到 <html>，避免首屏闪烁
const initialDarkMode = themeStorage.load();
document.documentElement.setAttribute(
  'data-theme',
  initialDarkMode ? 'dark' : 'light',
);

async function mountApp() {
  store.dispatch(setRuntimeConfig(await runtimeConfig));
  store.dispatch(setDarkMode(initialDarkMode));
  const { intlMessages, locale, antdLocale, antdValidateMessages } =
    await initI18n;
  debugLogger('initial state', store.getState());
  /**
   * Set user token from cookie
   */
  const cookieToken = getToken();
  if (cookieToken) {
    store.dispatch(setUserToken({ token: cookieToken, refresh: true }));
  }

  // 应用自定义 favicon（未配置时保持默认静态 favicon）
  applyBrandFavicon();

  // 渲染 APP
  ReactDOM.render(
    <StrictMode>
      <Provider store={store}>
        <IntlProvider locale={locale} messages={intlMessages}>
          <ConfigProvider
            locale={antdLocale}
            form={{ validateMessages: antdValidateMessages }}
          >
            <Router>
              <App />
            </Router>
          </ConfigProvider>
        </IntlProvider>
      </Provider>
    </StrictMode>,
    document.getElementById('root'),
  );
}

Promise.resolve().then(mountApp);
